import { Utils } from '@Util/utils'
import { MultiplierAnimation, MultiplierAnimationResult } from '../../multiplier-animation'
import {
  MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES,
  MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS,
} from './asset-preloader'
import { tweenPromise } from '@Animation/utils'
import {
  MI_MULTIPLIER_SHARED_ATLAS_FRAMES,
  MI_MULTIPLIER_SHARED_TEXTURE_KEYS,
} from '../shared/constants'

export class MichiganGumballMultiplierAnimation extends MultiplierAnimation {
  container: Phaser.GameObjects.Container
  machine: Phaser.GameObjects.Image
  coin: Phaser.GameObjects.Image
  gumballPile: Phaser.GameObjects.Image
  key: Phaser.GameObjects.Image
  flap: Phaser.GameObjects.Image
  background: Phaser.GameObjects.Image
  gumball: Phaser.GameObjects.Image
  spiral: Phaser.GameObjects.Image
  revealBall: Phaser.GameObjects.Image

  spiralMask: Phaser.Display.Masks.BitmapMask
  spiralMaskObj: Phaser.GameObjects.Image

  coinMask: Phaser.Display.Masks.BitmapMask
  coinMaskObj: Phaser.GameObjects.Image

  constructor(scene: Phaser.Scene, x: number, y: number, config: MultiplierAnimationResult) {
    super(scene, x, y, config)

    this.container = this.scene.add.container(0, 0)

    this.background = this.scene.add.image(
      0,
      0,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.BACKGROUND,
    )
    this.gumballPile = this.scene.add.image(
      0,
      0,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.BALL_PILE,
    )
    this.machine = this.scene.add.image(
      0,
      575,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.MACHINE,
    )
    this.key = this.scene.add.image(
      5,
      350,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.KEY,
    )
    this.key.setOrigin(0.5, 0.5)
    this.coin = this.scene.add.image(
      5,
      275,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.COIN,
    )

    this.spiral = this.scene.add.image(
      0,
      800,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.SPIRAL,
    )

    this.gumball = this.scene.add.image(
      100,
      425,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.BALL_BLURRY,
    )
    this.gumball.setOrigin(0.5, 0.5)

    this.flap = this.scene.add.image(
      0,
      1050,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.FLAP,
    )
    this.flap.setOrigin(0.5, 0)

    this.revealBall = this.scene.add.image(
      0,
      1090,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      `${MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.BALL_PREFIX}${this.multiplierValue}x.png`,
    )
    this.revealBall.setScale(0.16)
    this.revealBall.setOrigin(0.5, 0.5)

    this.add([this.background, this.container])
    this.container.add([
      this.gumballPile,
      this.spiral,
      this.gumball,
      this.machine,
      this.revealBall,
      this.flap,
      this.coin,
      this.key,
    ])

    this.spiralMaskObj = this.scene.add.image(
      250,
      this.spiral.y,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.SPIRAL_MASK,
    )

    this.spiralMaskObj.setVisible(false)
    this.spiralMask = new Phaser.Display.Masks.BitmapMask(this.scene, this.spiralMaskObj, 0, 0)
    this.spiralMask.invertAlpha = true

    this.coinMaskObj = this.scene.add.image(
      255,
      390,
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES.COIN_MASK,
    )
    this.coinMask = new Phaser.Display.Masks.BitmapMask(this.scene, this.coinMaskObj, 0, 0)
    this.coinMaskObj.setVisible(false)
    this.coinMask.invertAlpha = true
  }

  async play() {
    await this.showKickerLogo()
    await this.insertCoin()
    await this.ballDrop()
    await this.showResult()

    this.cleanup()
    this.destroy()
    return
  }

  async showKickerLogo() {
    const { width, height } = this.scene.sys.game.canvas

    const overlay = this.scene.add.graphics()
    overlay.fillStyle(0x000000, 0.5)
    overlay.fillRect(-width / 2, -height / 2, width, height)

    const heres = this.scene.add.image(
      -500,
      -100,
      MI_MULTIPLIER_SHARED_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_SHARED_ATLAS_FRAMES.HERES,
    )
    heres.setOrigin(0.5, 0.5)
    const the = this.scene.add.image(
      500,
      -25,
      MI_MULTIPLIER_SHARED_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_SHARED_ATLAS_FRAMES.THE,
    )
    the.setOrigin(0.5, 0.5)

    const kicker = this.scene.add.image(
      -250,
      -300,
      MI_MULTIPLIER_SHARED_TEXTURE_KEYS.ATLAS,
      MI_MULTIPLIER_SHARED_ATLAS_FRAMES.KICKER,
    )
    kicker.setOrigin(0.5, 0.5)
    kicker.alpha = 0

    const introDuration = 300

    const introHeres = tweenPromise(this.scene, {
      targets: heres,
      x: 10,
      duration: introDuration,
    })
    const introThe = tweenPromise(this.scene, {
      targets: the,
      x: -10,
      duration: introDuration,
    })
    const introKicker = tweenPromise(this.scene, {
      targets: kicker,
      x: 0,
      y: 50,
      alpha: 1,
      duration: introDuration,
    })

    this.add([overlay, kicker, heres, the])

    await Promise.all([introHeres(), introThe(), introKicker()])

    const driftDuration = 1100
    const driftHeres = tweenPromise(this.scene, {
      targets: heres,
      x: -25,
      duration: driftDuration,
    })

    const driftThe = tweenPromise(this.scene, {
      targets: the,
      x: 25,
      duration: driftDuration,
    })

    await Promise.all([driftHeres(), driftThe()])

    const outroDuration = 300

    const outroHeres = tweenPromise(this.scene, {
      targets: heres,
      x: 500,
      duration: outroDuration,
    })
    const outroThe = tweenPromise(this.scene, {
      targets: the,
      x: -500,
      duration: outroDuration,
    })
    const outroKicker = tweenPromise(this.scene, {
      targets: kicker,
      scale: 0.4,
      y: 200,
      alpha: 0,
      duration: outroDuration,
    })

    await Promise.all([outroHeres(), outroThe(), outroKicker()])

    heres.destroy()
    the.destroy()
    kicker.destroy()
    overlay.destroy()
  }

  async insertCoin() {
    await tweenPromise(this.scene, {
      targets: this.container,
      y: -200,
      duration: 500,
    })()
    this.coin.setMask(this.coinMask)

    await tweenPromise(this.scene, {
      targets: this.coin,
      y: this.coin.y + 55,
      duration: 500,
    })()

    this.coin.setVisible(false)

    const shakeGumballs = tweenPromise(this.scene, {
      targets: this.gumballPile,
      y: this.gumballPile.y - 11,
      ease: Phaser.Math.Easing.Bounce.Out,
      delay: 50,
      duration: 250,
      repeat: 1,
      yoyo: true,
    })
    await tweenPromise(this.scene, {
      targets: this.key,
      rotation: Math.PI,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out,
      repeat: 1,
      repeatDelay: 100,
      onStart: shakeGumballs,
    })()
  }

  async ballDrop() {
    const fallDuration = 3000
    const fallDistance = 800

    const controlPoints = []

    const startingY = 410
    const yGap = 128
    for (let i = 0; i < 4; i++) {
      const yPos = startingY + i * yGap
      controlPoints.push(new Phaser.Math.Vector2(99, yPos))
      controlPoints.push(new Phaser.Math.Vector2(0, yPos + yGap / 4))
      controlPoints.push(new Phaser.Math.Vector2(-97, yPos + yGap / 2))
      controlPoints.push(new Phaser.Math.Vector2(0, yPos + (3 * yGap) / 4))
    }

    controlPoints.push(new Phaser.Math.Vector2(99, startingY + 4 * yGap))
    controlPoints.push(new Phaser.Math.Vector2(0, startingY + 4 * yGap + (3 * yGap) / 4))

    // Create a path and add multiple cubic bezier curves to it
    const path = this.scene.add.path(controlPoints[0].x, controlPoints[0].y)

    for (let i = 0; i + 2 < controlPoints.length; i += 2) {
      path.splineTo([controlPoints[i], controlPoints[i + 1], controlPoints[i + 2]])
    }

    tweenPromise(this.scene, {
      targets: this.container,
      y: this.container.y - fallDistance,
      duration: fallDuration,
    })()

    await tweenPromise(this.scene, {
      targets: this.gumball,
      t: 1,
      ease: 'Linear',
      duration: fallDuration,
      onUpdate: (tween) => {
        const t = tween.progress
        const point = path.getPoint(t)
        if (point) {
          this.gumball.setPosition(point.x, point.y)

          if (point.x < -75) {
            this.gumball.setMask(this.spiralMask)
          } else if (point.x > 75) {
            this.gumball.clearMask()
          }

          if (point.x < -65) {
            this.container.moveBelow(this.gumball, this.spiral)
          } else if (point.x > 0) {
            this.container.moveAbove(this.gumball, this.spiral)
          }
        }
      },
    })()

    await tweenPromise(this.scene, {
      targets: this.gumball,
      y: 1100,
      x: 0,
      duration: 500,
    })()
  }

  async showResult() {
    await tweenPromise(this.scene, {
      targets: this.flap,
      scaleY: 0.02,
      duration: 500,
    })()

    this.container.bringToTop(this.revealBall)

    await tweenPromise(this.scene, {
      targets: this.revealBall,
      scale: 1.0,
      y: 1000,
      duration: 500,
    })()

    // TODO: Ball Shine

    await Utils.sleep(1000)
  }

  destroy(fromScene?: boolean): void {
    this.container.removeAll(true)
    this.spiralMaskObj.destroy()
    this.coinMaskObj.destroy()
    this.removeAll(true)
    super.destroy(fromScene)
  }
}
